import React from 'react';
import PropTypes from 'prop-types';
import EnteredIntoPrizeDraw from './Entered';
import NotEnteredIntoPrizeDraw from './NotEntered';

const PrizeDraw = ({ raceName, didEntryWin, prize }) => (
    <>
        {didEntryWin ? (
            <EnteredIntoPrizeDraw raceName={raceName} prize={prize} />
        ) : (
            <NotEnteredIntoPrizeDraw raceName={raceName} />
        )}
    </>
);

PrizeDraw.propTypes = {
    raceName: PropTypes.string.isRequired,
    didEntryWin: PropTypes.bool.isRequired,
    prize: PropTypes.string.isRequired
};

export default PrizeDraw;
